function show_description(id_description,btn_min,btn_mor) {
  $('#'+id_description).slideToggle( "slow", function() {

  });

  var element = document.getElementById(id_description);
  element.classList.remove("style_hide");
  element.classList.add("style_show");

  var btn_minus = document.getElementById(btn_min);
  var btn_more = document.getElementById(btn_mor);

  btn_more.classList.remove("style_show");
  btn_more.classList.add("style_hide");

  btn_minus.classList.remove("style_hide")
  btn_minus.classList.add("style_show");  
}
  

function hide_description(id_description,btn_min,btn_mor){  
  $('#'+id_description).slideToggle( "slow", function() {

  });

  var element = document.getElementById(id_description);
  element.classList.remove("style_show");
  element.classList.add("style_hide");

  var btn_minus = document.getElementById(btn_min);
  var btn_more = document.getElementById(btn_mor);

  btn_minus.classList.remove("style_show")
  btn_minus.classList.add("style_hide");

  btn_more.classList.add("style_show");
  btn_more.classList.remove("style_hide");
}

function onClick(element) {
  var image_src = $(element).attr("data-src");
  document.getElementById("img01").src = image_src;
  document.getElementById("modal01").style.display = "block";
}


$(window).scroll(function() {
    if ($(this).scrollTop() > 300) {
        $('a.scroll-top').fadeIn('slow');
    } else {
        $('a.scroll-top').fadeOut('slow');
    }
});
$('a.scroll-top').click(function(event) {
    event.preventDefault();
    $('html, body').animate({scrollTop: 0}, 600);
});

$(document).ready(() => {
  $(".lightgallery").lightGallery({
    pager: true,
    download: false,
    share: false,
  });
});


$('#options-colec').change(function() {
    var value_option = $(this).val();
  console.log(value_option);
    $('html, body').animate({
      scrollTop: $("#"+value_option).offset().top
    }, 1000);
});
